import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ExpenseImmobilier, ExpenseType, PaymentStatus, PaymentMethod } from '../../models/expense-immobilier';

@Component({
    selector: 'app-expense-detail-dialog',
    templateUrl: './expense-detail-dialog.component.html',
    styleUrls: ['./expense-detail-dialog.component.css']
})
export class ExpenseDetailDialogComponent implements OnInit {

    expense: ExpenseImmobilier;

    constructor(
        public dialogRef: MatDialogRef<ExpenseDetailDialogComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any
    ) {
        this.expense = data.expense;
    }

    ngOnInit(): void {
    }

    close(): void {
        this.dialogRef.close();
    }

    print(): void {
        window.print();
    }

    getPaymentStatusColor(status: PaymentStatus): string {
        const colors: { [key: string]: string } = {
            'non_paye': 'red',
            'partiel': 'orange',
            'paye': 'green',
            'en_retard': 'red'
        };
        return colors[status] || 'gray';
    }

    getPaymentStatusLabel(status: PaymentStatus): string {
        const labels: { [key: string]: string } = {
            'non_paye': 'Non payé',
            'partiel': 'Partiel',
            'paye': 'Payé',
            'en_retard': 'En retard'
        };
        return labels[status] || status;
    }

    getTypeLabel(type: ExpenseType): string {
        const labels: { [key: string]: string } = {
            'maintenance': 'Maintenance',
            'taxe': 'Taxe',
            'assurance': 'Assurance',
            'charges': 'Charges',
            'amenagement': 'Aménagement',
            'foncier': 'Foncier',
            'copropriete': 'Copropriété',
            'syndic': 'Syndic',
            'autre': 'Autre'
        };
        return labels[type] || type;
    }

    getPaymentMethodLabel(method?: PaymentMethod): string {
        if (!method) return '-';
        const labels: { [key: string]: string } = {
            'virement': 'Virement',
            'cheque': 'Chèque',
            'especes': 'Espèces',
            'carte': 'Carte Bancaire',
            'prelevement': 'Prélèvement',
            'autre': 'Autre'
        };
        return labels[method] || method;
    }

    formatPrice(price?: number): string {
        if (!price) return '0 FCFA';
        return new Intl.NumberFormat('fr-FR', {
            style: 'currency',
            currency: 'XOF'
        }).format(price);
    }

    formatDate(date?: Date): string {
        if (!date) return '-';
        return new Date(date).toLocaleDateString('fr-FR');
    }
}
